@if (showWhatsappWarning()) {
  <app-modal class="z-50">
    <div class="space-y-6 max-w-2xl mx-auto text-center">
      <p class="text-gray-700">
        <strong>Para abrir tu ahorro programado debes continuar en el navegador</strong>
        (Safari, Chrome u otro).
      </p>
      @if (!isAndroidUA()) {
        <a
          [href]="getExternalRedirectUrl()"
          target="_blank"
          rel="noopener noreferrer"
          class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg no-underline inline-block">
          Continuar en navegador externo
        </a>
      } @else {
        <button type="button" (click)="openInExternalBrowser()" class="btn-primary">
          Continuar en navegador externo
        </button>
      }
    </div>
  </app-modal>
}

@if (showIntro()) {
  <div class="flex flex-col items-center justify-center text-center space-y-4 mt-10">
    <img src="svg/pig.svg" class="h-16 w-16" alt="Ahorro programado">
    <p class="text-dark-blue font-bold text-lg">
      ¡Dale un impulso extra a tu dinero!<br>
      Abre tu ahorro programado
    </p>
    <p class="text-base text-[14.5px] max-w-md">
      Planea un ahorro extra al aporte social y camina hacia el cumplimiento de tus propósitos.
    </p>
    <button class="btn-primary" (click)="openPap()">
      Abrir nuevo ahorro
    </button>
    <button class="btn-secundary" (click)="rejectPap()">
      No, gracias
    </button>
  </div>
}

@if (showError()) {
  <app-error-screen
    [title]="titleError"
    (close)="retry()"
    [description]="descriptionError">
  </app-error-screen>
}
